import { urlSearch } from '@/search';

export default () => urlSearch.getValue('status') || 'open';
